import { render } from "./CadastroCarreta.vue?vue&type=template&id=59e2b4ca&scoped=true"
import script from "./CadastroCarreta.vue?vue&type=script&lang=ts"
export * from "./CadastroCarreta.vue?vue&type=script&lang=ts"

import "./CadastroCarreta.vue?vue&type=style&index=0&id=59e2b4ca&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-59e2b4ca"

export default script